import armFlag from '../assets/icons/flags/arm-flag.svg';
import enFlag from '../assets/icons/flags/en-flag.svg';
import ruFlag from '../assets/icons/flags/ru-flag.svg';

export const cities = [
  { name: 'New York', code: 'NY' },
  { name: 'Rome', code: 'RM' },
  { name: 'London', code: 'LDN' },
  { name: 'Paris', code: 'PRS' },
];
export const locales = [
  { name: 'AM', code: 'am', icon: armFlag },
  { name: 'EN', code: 'en', icon: enFlag },
  { name: 'RU', code: 'ru', icon: ruFlag },
];
